export default __webpack_public_path__ + "static/media/demand.d94f829e.svg";